// Translations for Trust Ed Techno Platform
export const translations = {
  ar: {
    // Brand
    brandName: "Trust Ed Techno",
    brandNameAr: "ترست اي دي تكنو للتطوير والابتكار ذ.م.م",
    tagline: "منصة تقنية تربط الطلاب بالأساتذة المستقلين في الإمارات",
    copyright: "© 2026 ترست اي دي تكنو للتطوير والابتكار ذ.م.م. جميع الحقوق محفوظة.",
    
    // Navigation
    home: "الرئيسية",
    login: "تسجيل الدخول",
    register: "إنشاء حساب",
    logout: "تسجيل الخروج",
    dashboard: "لوحة التحكم",
    profile: "الملف الشخصي",
    settings: "الإعدادات",
    
    // Roles
    student: "طالب",
    teacher: "أستاذ",
    admin: "مدير",
    
    // Auth
    email: "البريد الإلكتروني",
    password: "كلمة المرور",
    confirmPassword: "تأكيد كلمة المرور",
    fullName: "الاسم الكامل",
    phone: "رقم الهاتف",
    registerAs: "أريد التسجيل كـ",
    alreadyHaveAccount: "لديك حساب بالفعل؟",
    dontHaveAccount: "ليس لديك حساب؟",
    loginNow: "سجل دخولك",
    registerNow: "سجل الآن",
    welcomeBack: "مرحباً بعودتك",
    createAccount: "إنشاء حساب جديد",
    
    // Terms
    acceptTerms: "أوافق على الشروط والأحكام",
    termsAndConditions: "الشروط والأحكام",
    mustAcceptTerms: "يجب الموافقة على الشروط والأحكام",
    
    // Subscription
    subscription: "الاشتراك",
    trialPeriod: "فترة تجريبية",
    daysRemaining: "أيام متبقية",
    subscriptionExpired: "انتهى الاشتراك",
    renewSubscription: "تجديد الاشتراك",
    monthlyPlan: "اشتراك شهري",
    yearlyPlan: "اشتراك سنوي",
    perMonth: "شهرياً",
    perYear: "سنوياً",
    subscribe: "اشترك الآن",
    subscriptionRequired: "عذراً، لا يمكنك الدخول. يرجى تجديد اشتراكك.",
    freeTrial: "3 أيام تجريبية مجانية",
    
    // Teachers
    findTeacher: "ابدأ التعلم الآن",
    verifiedTeacher: "أستاذ موثوق",
    verified: "موثوق ✓",
    subjects: "المواد الدراسية",
    experience: "سنوات الخبرة",
    hourlyRate: "سعر الساعة",
    rating: "التقييم",
    reviews: "المراجعات",
    noReviews: "لا توجد مراجعات بعد",
    
    // Filters
    filters: "الفلاتر",
    clearFilters: "مسح الفلاتر",
    subject: "المادة",
    emirate: "الإمارة",
    gender: "الجنس",
    male: "ذكر",
    female: "أنثى",
    lessonType: "نوع الدرس",
    online: "عن بعد",
    inPerson: "حضوري",
    minRating: "الحد الأدنى للتقييم",
    maxPrice: "الحد الأقصى للسعر",
    minExperience: "الحد الأدنى للخبرة",
    verifiedOnly: "الموثوقون فقط",
    
    // Bookings
    bookLesson: "احجز درسك",
    myBookings: "حجوزاتي",
    upcomingLessons: "الدروس القادمة",
    completedLessons: "الدروس المكتملة",
    cancelledLessons: "الدروس الملغية",
    pending: "قيد الانتظار",
    confirmed: "مؤكد",
    completed: "مكتمل",
    cancelled: "ملغي",
    
    // Payment
    payment: "الدفع",
    payNow: "ادفع الآن",
    totalAmount: "الإجمالي",
    vat: "ضريبة القيمة المضافة",
    platformFee: "رسوم المنصة",
    teacherEarnings: "أرباح الأستاذ",
    paid: "مدفوع",
    paymentPending: "بانتظار الدفع",
    paymentSuccess: "تم الدفع بنجاح!",
    paymentCancelled: "تم إلغاء الدفع",
    
    // Messages
    messages: "الرسائل",
    noMessages: "لا توجد رسائل",
    typeMessage: "اكتب رسالتك...",
    send: "إرسال",
    
    // Calendar
    calendar: "التقويم",
    
    // Profile
    editProfile: "تعديل الملف الشخصي",
    qualifications: "المؤهلات",
    certificates: "الشهادات",
    uploadCertificate: "رفع شهادة",
    bio: "نبذة عني",
    meetingLink: "رابط الاجتماع",
    
    // Admin
    adminDashboard: "لوحة تحكم الإدارة",
    manageTeachers: "إدارة الأساتذة",
    manageUsers: "إدارة المستخدمين",
    manageSubjects: "إدارة المواد",
    manageReviews: "إدارة المراجعات",
    financialReports: "التقارير المالية",
    approve: "موافقة",
    reject: "رفض",
    activate: "تفعيل",
    deactivate: "تعطيل",
    pendingApproval: "بانتظار الموافقة",
    
    // Stats
    totalUsers: "إجمالي المستخدمين",
    totalStudents: "الطلاب",
    totalTeachers: "الأساتذة",
    totalBookings: "الحجوزات",
    totalRevenue: "إجمالي الإيرادات",
    platformRevenue: "إيرادات المنصة",
    subscriptionRevenue: "إيرادات الاشتراكات",
    
    // Common
    save: "حفظ",
    cancel: "إلغاء",
    delete: "حذف",
    edit: "تعديل",
    view: "عرض",
    loading: "جاري التحميل...",
    noResults: "لا توجد نتائج",
    success: "تم بنجاح",
    error: "حدث خطأ",
    confirm: "تأكيد",
    back: "رجوع",
    next: "التالي",
    previous: "السابق",
    
    // Contact
    contactUs: "تواصل معنا",
    address: "العنوان",
    addressValue: "أبوظبي، الإمارات العربية المتحدة",
    
    // Actions
    messageTeacher: "راسل الأستاذ",
    bookNow: "احجز الآن",
    viewProfile: "عرض الملف",
    searchTeachers: "البحث عن أساتذة",
    requestSpecialist: "طلب حجز متخصص",
    cancelBooking: "إلغاء الحجز",
    joinClassroom: "دخول الغرفة الصفية",
    startLesson: "بدء الدرس",
    endLesson: "إنهاء الدرس",
    
    // Free Lessons
    freeLessons: "دروس مجانية",
    freeLesson: "درس مجاني",
    enableFreeLessons: "تفعيل الدروس المجانية",
    freeLessonsPerMonth: "عدد الدروس المجانية شهرياً",
    freeLessonsRemaining: "الدروس المتبقية",
    
    // Withdrawals
    withdrawals: "سحب الأرباح",
    requestWithdrawal: "طلب سحب",
    availableBalance: "الرصيد المتاح",
    totalEarnings: "إجمالي الأرباح",
    
    // Status
    statusPending: "قيد الانتظار",
    statusConfirmed: "مؤكد",
    statusCompleted: "مكتمل",
    statusCancelled: "ملغي",
    statusApproved: "تمت الموافقة",
    statusRejected: "مرفوض",
  },
  
  en: {
    // Brand
    brandName: "Trust Ed Techno",
    brandNameAr: "ترست اي دي تكنو للتطوير والابتكار ذ.م.م",
    tagline: "Connecting Students with Independent Tutors in UAE",
    copyright: "© 2026 Trust Ed Techno for Development and Innovation L.L.C. All rights reserved.",
    
    // Navigation
    home: "Home",
    login: "Login",
    register: "Register",
    logout: "Logout",
    dashboard: "Dashboard",
    profile: "Profile",
    settings: "Settings",
    
    // Roles
    student: "Student",
    teacher: "Teacher",
    admin: "Admin",
    
    // Auth
    email: "Email",
    password: "Password",
    confirmPassword: "Confirm Password",
    fullName: "Full Name",
    phone: "Phone Number",
    registerAs: "Register as",
    alreadyHaveAccount: "Already have an account?",
    dontHaveAccount: "Don't have an account?",
    loginNow: "Login",
    registerNow: "Register Now",
    welcomeBack: "Welcome Back",
    createAccount: "Create New Account",
    
    // Terms
    acceptTerms: "I accept the Terms and Conditions",
    termsAndConditions: "Terms and Conditions",
    mustAcceptTerms: "You must accept the terms and conditions",
    
    // Subscription
    subscription: "Subscription",
    trialPeriod: "Trial Period",
    daysRemaining: "days remaining",
    subscriptionExpired: "Subscription Expired",
    renewSubscription: "Renew Subscription",
    monthlyPlan: "Monthly Plan",
    yearlyPlan: "Yearly Plan",
    perMonth: "/month",
    perYear: "/year",
    subscribe: "Subscribe Now",
    subscriptionRequired: "Sorry, you cannot access. Please renew your subscription.",
    freeTrial: "3 Days Free Trial",
    
    // Teachers
    findTeacher: "Start Learning Now",
    verifiedTeacher: "Verified Teacher",
    verified: "Verified ✓",
    subjects: "Subjects",
    experience: "Years of Experience",
    hourlyRate: "Hourly Rate",
    rating: "Rating",
    reviews: "Reviews",
    noReviews: "No reviews yet",
    
    // Filters
    filters: "Filters",
    clearFilters: "Clear Filters",
    subject: "Subject",
    emirate: "Emirate",
    gender: "Gender",
    male: "Male",
    female: "Female",
    lessonType: "Lesson Type",
    online: "Online",
    inPerson: "In Person",
    minRating: "Minimum Rating",
    maxPrice: "Maximum Price",
    minExperience: "Minimum Experience",
    verifiedOnly: "Verified Only",
    
    // Bookings
    bookLesson: "Book a Lesson",
    myBookings: "My Bookings",
    upcomingLessons: "Upcoming Lessons",
    completedLessons: "Completed Lessons",
    cancelledLessons: "Cancelled Lessons",
    pending: "Pending",
    confirmed: "Confirmed",
    completed: "Completed",
    cancelled: "Cancelled",
    
    // Payment
    payment: "Payment",
    payNow: "Pay Now",
    totalAmount: "Total Amount",
    vat: "VAT",
    platformFee: "Platform Fee",
    teacherEarnings: "Teacher Earnings",
    paid: "Paid",
    paymentPending: "Payment Pending",
    paymentSuccess: "Payment Successful!",
    paymentCancelled: "Payment Cancelled",
    
    // Messages
    messages: "Messages",
    noMessages: "No messages",
    typeMessage: "Type your message...",
    send: "Send",
    
    // Calendar
    calendar: "Calendar",
    
    // Profile
    editProfile: "Edit Profile",
    qualifications: "Qualifications",
    certificates: "Certificates",
    uploadCertificate: "Upload Certificate",
    bio: "About Me",
    meetingLink: "Meeting Link",
    
    // Admin
    adminDashboard: "Admin Dashboard",
    manageTeachers: "Manage Teachers",
    manageUsers: "Manage Users",
    manageSubjects: "Manage Subjects",
    manageReviews: "Manage Reviews",
    financialReports: "Financial Reports",
    approve: "Approve",
    reject: "Reject",
    activate: "Activate",
    deactivate: "Deactivate",
    pendingApproval: "Pending Approval",
    
    // Stats
    totalUsers: "Total Users",
    totalStudents: "Students",
    totalTeachers: "Teachers",
    totalBookings: "Bookings",
    totalRevenue: "Total Revenue",
    platformRevenue: "Platform Revenue",
    subscriptionRevenue: "Subscription Revenue",
    
    // Common
    save: "Save",
    cancel: "Cancel",
    delete: "Delete",
    edit: "Edit",
    view: "View",
    loading: "Loading...",
    noResults: "No results",
    success: "Success",
    error: "Error",
    confirm: "Confirm",
    back: "Back",
    next: "Next",
    previous: "Previous",
    
    // Contact
    contactUs: "Contact Us",
    address: "Address",
    addressValue: "Abu Dhabi, United Arab Emirates",
    
    // Actions
    messageTeacher: "Message Teacher",
    bookNow: "Book Now",
    viewProfile: "View Profile",
    searchTeachers: "Search Teachers",
    requestSpecialist: "Request Specialist",
    cancelBooking: "Cancel Booking",
    joinClassroom: "Join Classroom",
    startLesson: "Start Lesson",
    endLesson: "End Lesson",
    
    // Free Lessons
    freeLessons: "Free Lessons",
    freeLesson: "Free Lesson",
    enableFreeLessons: "Enable Free Lessons",
    freeLessonsPerMonth: "Free Lessons Per Month",
    freeLessonsRemaining: "Remaining Lessons",
    
    // Withdrawals
    withdrawals: "Withdrawals",
    requestWithdrawal: "Request Withdrawal",
    availableBalance: "Available Balance",
    totalEarnings: "Total Earnings",
    
    // Status
    statusPending: "Pending",
    statusConfirmed: "Confirmed",
    statusCompleted: "Completed",
    statusCancelled: "Cancelled",
    statusApproved: "Approved",
    statusRejected: "Rejected",
  },
  es: {
    brandName: "Trust Ed Techno",
    brandNameAr: "ترست اي دي تكنو للتطوير والابتكار ذ.م.م",
    tagline: "Conectando Estudiantes con Tutores Independientes en EAU",
    copyright: "© 2026 Trust Ed Techno for Development and Innovation L.L.C. Todos los derechos reservados.",
    home: "Inicio",
    login: "Iniciar Sesión",
    register: "Registrarse",
    logout: "Cerrar Sesión",
    dashboard: "Panel de Control",
    profile: "Perfil",
    settings: "Configuración",
    student: "Estudiante",
    teacher: "Profesor",
    admin: "Administrador",
    email: "Correo Electrónico",
    password: "Contraseña",
    confirmPassword: "Confirmar Contraseña",
    fullName: "Nombre Completo",
    phone: "Número de Teléfono",
    registerAs: "Registrarse como",
    alreadyHaveAccount: "¿Ya tienes una cuenta?",
    dontHaveAccount: "¿No tienes una cuenta?",
    loginNow: "Iniciar Sesión",
    registerNow: "Registrarse Ahora",
    welcomeBack: "Bienvenido de Nuevo",
    createAccount: "Crear Nueva Cuenta",
    acceptTerms: "Acepto los Términos y Condiciones",
    termsAndConditions: "Términos y Condiciones",
    mustAcceptTerms: "Debes aceptar los términos y condiciones",
    subscription: "Suscripción",
    trialPeriod: "Período de Prueba",
    daysRemaining: "días restantes",
    subscriptionExpired: "Suscripción Expirada",
    renewSubscription: "Renovar Suscripción",
    monthlyPlan: "Plan Mensual",
    yearlyPlan: "Plan Anual",
    perMonth: "/mes",
    perYear: "/año",
    subscribe: "Suscribirse Ahora",
    subscriptionRequired: "Lo sentimos, no puedes acceder. Por favor renueva tu suscripción.",
    freeTrial: "3 Días de Prueba Gratis",
    findTeacher: "Comienza a Aprender Ahora",
    verifiedTeacher: "Profesor Verificado",
    verified: "Verificado ✓",
    subjects: "Materias",
    experience: "Años de Experiencia",
    hourlyRate: "Tarifa por Hora",
    rating: "Calificación",
    reviews: "Reseñas",
    noReviews: "Aún no hay reseñas",
    filters: "Filtros",
    clearFilters: "Limpiar Filtros",
    subject: "Materia",
    emirate: "Emirato",
    gender: "Género",
    male: "Masculino",
    female: "Femenino",
    lessonType: "Tipo de Lección",
    online: "En Línea",
    inPerson: "Presencial",
    minRating: "Calificación Mínima",
    maxPrice: "Precio Máximo",
    minExperience: "Experiencia Mínima",
    verifiedOnly: "Solo Verificados",
    bookLesson: "Reservar una Lección",
    myBookings: "Mis Reservas",
    upcomingLessons: "Lecciones Próximas",
    completedLessons: "Lecciones Completadas",
    cancelledLessons: "Lecciones Canceladas",
    pending: "Pendiente",
    confirmed: "Confirmado",
    completed: "Completado",
    cancelled: "Cancelado",
    payment: "Pago",
    payNow: "Pagar Ahora",
    totalAmount: "Monto Total",
    vat: "IVA",
    platformFee: "Comisión de Plataforma",
    teacherEarnings: "Ganancias del Profesor",
    paid: "Pagado",
    paymentPending: "Pago Pendiente",
    paymentSuccess: "¡Pago Exitoso!",
    paymentCancelled: "Pago Cancelado",
    messages: "Mensajes",
    noMessages: "No hay mensajes",
    typeMessage: "Escribe tu mensaje...",
    send: "Enviar",
    calendar: "Calendario",
    editProfile: "Editar Perfil",
    qualifications: "Cualificaciones",
    certificates: "Certificados",
    uploadCertificate: "Subir Certificado",
    bio: "Acerca de Mí",
    meetingLink: "Enlace de Reunión",
    adminDashboard: "Panel de Administración",
    manageTeachers: "Gestionar Profesores",
    manageUsers: "Gestionar Usuarios",
    manageSubjects: "Gestionar Materias",
    manageReviews: "Gestionar Reseñas",
    financialReports: "Informes Financieros",
    approve: "Aprobar",
    reject: "Rechazar",
    activate: "Activar",
    deactivate: "Desactivar",
    pendingApproval: "Pendiente de Aprobación",
    totalUsers: "Total de Usuarios",
    totalStudents: "Estudiantes",
    totalTeachers: "Profesores",
    totalBookings: "Reservas",
    totalRevenue: "Ingresos Totales",
    platformRevenue: "Ingresos de Plataforma",
    subscriptionRevenue: "Ingresos por Suscripción",
    save: "Guardar",
    cancel: "Cancelar",
    delete: "Eliminar",
    edit: "Editar",
    view: "Ver",
    loading: "Cargando...",
    noResults: "Sin resultados",
    success: "Éxito",
    error: "Error",
    confirm: "Confirmar",
    back: "Atrás",
    next: "Siguiente",
    previous: "Anterior",
    contactUs: "Contáctanos",
    address: "Dirección",
    addressValue: "Abu Dhabi, Emiratos Árabes Unidos",
    messageTeacher: "Mensaje al Profesor",
    bookNow: "Reservar Ahora",
    viewProfile: "Ver Perfil",
    searchTeachers: "Buscar Profesores",
    requestSpecialist: "Solicitar Especialista",
    cancelBooking: "Cancelar Reserva",
    joinClassroom: "Unirse a la Clase",
    startLesson: "Iniciar Lección",
    endLesson: "Finalizar Lección",
    freeLessons: "Lecciones Gratis",
    freeLesson: "Lección Gratis",
    enableFreeLessons: "Habilitar Lecciones Gratis",
    freeLessonsPerMonth: "Lecciones Gratis por Mes",
    freeLessonsRemaining: "Lecciones Restantes",
    withdrawals: "Retiros",
    requestWithdrawal: "Solicitar Retiro",
    availableBalance: "Saldo Disponible",
    totalEarnings: "Ganancias Totales",
    statusPending: "Pendiente",
    statusConfirmed: "Confirmado",
    statusCompleted: "Completado",
    statusCancelled: "Cancelado",
    statusApproved: "Aprobado",
    statusRejected: "Rechazado",
  },
  hi: {
    brandName: "Trust Ed Techno",
    brandNameAr: "ترست اي دي تكنو للتطوير والابتكار ذ.م.م",
    tagline: "यूएई में छात्रों को स्वतंत्र शिक्षकों से जोड़ना",
    copyright: "© 2026 Trust Ed Techno for Development and Innovation L.L.C. सर्वाधिकार सुरक्षित।",
    home: "होम",
    login: "लॉगिन",
    register: "रजिस्टर करें",
    logout: "लॉगआउट",
    dashboard: "डैशबोर्ड",
    profile: "प्रोफ़ाइल",
    settings: "सेटिंग्स",
    student: "छात्र",
    teacher: "शिक्षक",
    admin: "एडमिन",
    email: "ईमेल",
    password: "पासवर्ड",
    confirmPassword: "पासवर्ड की पुष्टि करें",
    fullName: "पूरा नाम",
    phone: "फ़ोन नंबर",
    registerAs: "इस रूप में रजिस्टर करें",
    alreadyHaveAccount: "पहले से खाता है?",
    dontHaveAccount: "खाता नहीं है?",
    loginNow: "लॉगिन करें",
    registerNow: "अभी रजिस्टर करें",
    welcomeBack: "वापसी पर स्वागत है",
    createAccount: "नया खाता बनाएं",
    acceptTerms: "मैं नियम और शर्तें स्वीकार करता/करती हूं",
    termsAndConditions: "नियम और शर्तें",
    mustAcceptTerms: "आपको नियम और शर्तें स्वीकार करनी होंगी",
    subscription: "सब्सक्रिप्शन",
    trialPeriod: "ट्रायल अवधि",
    daysRemaining: "दिन शेष",
    subscriptionExpired: "सब्सक्रिप्शन समाप्त हो गई",
    renewSubscription: "सब्सक्रिप्शन नवीनीकृत करें",
    monthlyPlan: "मासिक योजना",
    yearlyPlan: "वार्षिक योजना",
    perMonth: "/माह",
    perYear: "/वर्ष",
    subscribe: "अभी सब्सक्राइब करें",
    subscriptionRequired: "क्षमा करें, आप एक्सेस नहीं कर सकते। कृपया अपनी सब्सक्रिप्शन नवीनीकृत करें।",
    freeTrial: "3 दिन का निःशुल्क ट्रायल",
    findTeacher: "अभी सीखना शुरू करें",
    verifiedTeacher: "सत्यापित शिक्षक",
    verified: "सत्यापित ✓",
    subjects: "विषय",
    experience: "अनुभव के वर्ष",
    hourlyRate: "प्रति घंटा दर",
    rating: "रेटिंग",
    reviews: "समीक्षाएं",
    noReviews: "अभी तक कोई समीक्षा नहीं",
    filters: "फ़िल्टर",
    clearFilters: "फ़िल्टर साफ़ करें",
    subject: "विषय",
    emirate: "अमीरात",
    gender: "लिंग",
    male: "पुरुष",
    female: "महिला",
    lessonType: "पाठ का प्रकार",
    online: "ऑनलाइन",
    inPerson: "व्यक्तिगत रूप से",
    minRating: "न्यूनतम रेटिंग",
    maxPrice: "अधिकतम मूल्य",
    minExperience: "न्यूनतम अनुभव",
    verifiedOnly: "केवल सत्यापित",
    bookLesson: "पाठ बुक करें",
    myBookings: "मेरी बुकिंग",
    upcomingLessons: "आगामी पाठ",
    completedLessons: "पूर्ण किए गए पाठ",
    cancelledLessons: "रद्द किए गए पाठ",
    pending: "लंबित",
    confirmed: "पुष्टि की गई",
    completed: "पूर्ण",
    cancelled: "रद्द",
    payment: "भुगतान",
    payNow: "अभी भुगतान करें",
    totalAmount: "कुल राशि",
    vat: "वैट",
    platformFee: "प्लेटफॉर्म शुल्क",
    teacherEarnings: "शिक्षक की कमाई",
    paid: "भुगतान किया गया",
    paymentPending: "भुगतान लंबित",
    paymentSuccess: "भुगतान सफल रहा!",
    paymentCancelled: "भुगतान रद्द किया गया",
    messages: "संदेश",
    noMessages: "कोई संदेश नहीं",
    typeMessage: "अपना संदेश टाइप करें...",
    send: "भेजें",
    calendar: "कैलेंडर",
    editProfile: "प्रोफ़ाइल संपादित करें",
    qualifications: "योग्यताएं",
    certificates: "प्रमाणपत्र",
    uploadCertificate: "प्रमाणपत्र अपलोड करें",
    bio: "मेरे बारे में",
    meetingLink: "मीटिंग लिंक",
    adminDashboard: "एडमिन डैशबोर्ड",
    manageTeachers: "शिक्षकों का प्रबंधन",
    manageUsers: "उपयोगकर्ताओं का प्रबंधन",
    manageSubjects: "विषयों का प्रबंधन",
    manageReviews: "समीक्षाओं का प्रबंधन",
    financialReports: "वित्तीय रिपोर्ट",
    approve: "स्वीकृत करें",
    reject: "अस्वीकार करें",
    activate: "सक्रिय करें",
    deactivate: "निष्क्रिय करें",
    pendingApproval: "स्वीकृति लंबित",
    totalUsers: "कुल उपयोगकर्ता",
    totalStudents: "छात्र",
    totalTeachers: "शिक्षक",
    totalBookings: "बुकिंग",
    totalRevenue: "कुल राजस्व",
    platformRevenue: "प्लेटफॉर्म राजस्व",
    subscriptionRevenue: "सब्सक्रिप्शन राजस्व",
    save: "सहेजें",
    cancel: "रद्द करें",
    delete: "हटाएं",
    edit: "संपादित करें",
    view: "देखें",
    loading: "लोड हो रहा है...",
    noResults: "कोई परिणाम नहीं",
    success: "सफल",
    error: "त्रुटि",
    confirm: "पुष्टि करें",
    back: "वापस",
    next: "अगला",
    previous: "पिछला",
    contactUs: "संपर्क करें",
    address: "पता",
    addressValue: "अबू धाबी, संयुक्त अरब अमीरात",
    messageTeacher: "शिक्षक को संदेश भेजें",
    bookNow: "अभी बुक करें",
    viewProfile: "प्रोफ़ाइल देखें",
    searchTeachers: "शिक्षक खोजें",
    requestSpecialist: "विशेषज्ञ का अनुरोध करें",
    cancelBooking: "बुकिंग रद्द करें",
    joinClassroom: "कक्षा में शामिल हों",
    startLesson: "पाठ शुरू करें",
    endLesson: "पाठ समाप्त करें",
    freeLessons: "निःशुल्क पाठ",
    freeLesson: "निःशुल्क पाठ",
    enableFreeLessons: "निःशुल्क पाठ सक्षम करें",
    freeLessonsPerMonth: "प्रति माह निःशुल्क पाठ",
    freeLessonsRemaining: "शेष पाठ",
    withdrawals: "निकासी",
    requestWithdrawal: "निकासी का अनुरोध करें",
    availableBalance: "उपलब्ध शेष",
    totalEarnings: "कुल कमाई",
    statusPending: "लंबित",
    statusConfirmed: "पुष्टि की गई",
    statusCompleted: "पूर्ण",
    statusCancelled: "रद्द",
    statusApproved: "स्वीकृत",
    statusRejected: "अस्वीकृत",
  },
  ur: {
    brandName: "Trust Ed Techno",
    brandNameAr: "ترست اي دي تكنو للتطوير والابتكار ذ.م.م",
    tagline: "متحدہ عرب امارات میں طلباء کو آزاد ٹیوٹرز سے جوڑنا",
    copyright: "© 2026 Trust Ed Techno for Development and Innovation L.L.C. تمام حقوق محفوظ ہیں۔",
    home: "ہوم",
    login: "لاگ ان",
    register: "رجسٹر کریں",
    logout: "لاگ آؤٹ",
    dashboard: "ڈیش بورڈ",
    profile: "پروفائل",
    settings: "ترتیبات",
    student: "طالب علم",
    teacher: "استاد",
    admin: "ایڈمن",
    email: "ای میل",
    password: "پاس ورڈ",
    confirmPassword: "پاس ورڈ کی تصدیق کریں",
    fullName: "پورا نام",
    phone: "فون نمبر",
    registerAs: "بطور رجسٹر کریں",
    alreadyHaveAccount: "پہلے سے اکاؤنٹ ہے؟",
    dontHaveAccount: "اکاؤنٹ نہیں ہے؟",
    loginNow: "لاگ ان کریں",
    registerNow: "ابھی رجسٹر کریں",
    welcomeBack: "خوش آمدید",
    createAccount: "نیا اکاؤنٹ بنائیں",
    acceptTerms: "میں شرائط و ضوابط کو قبول کرتا ہوں",
    termsAndConditions: "شرائط و ضوابط",
    mustAcceptTerms: "آپ کو شرائط و ضوابط قبول کرنا ضروری ہے",
    subscription: "سبسکرپشن",
    trialPeriod: "ٹرائل مدت",
    daysRemaining: "دن باقی",
    subscriptionExpired: "سبسکرپشن ختم ہو گئی",
    renewSubscription: "سبسکرپشن کی تجدید کریں",
    monthlyPlan: "ماہانہ پلان",
    yearlyPlan: "سالانہ پلان",
    perMonth: "/ماہ",
    perYear: "/سال",
    subscribe: "ابھی سبسکرائب کریں",
    subscriptionRequired: "معذرت، آپ رسائی نہیں کر سکتے۔ براہ کرم اپنی سبسکرپشن کی تجدید کریں۔",
    freeTrial: "3 دن مفت ٹرائل",
    findTeacher: "ابھی سیکھنا شروع کریں",
    verifiedTeacher: "تصدیق شدہ استاد",
    verified: "تصدیق شدہ ✓",
    subjects: "مضامین",
    experience: "تجربہ کے سال",
    hourlyRate: "فی گھنٹہ ریٹ",
    rating: "درجہ بندی",
    reviews: "جائزے",
    noReviews: "ابھی تک کوئی جائزہ نہیں",
    filters: "فلٹرز",
    clearFilters: "فلٹرز صاف کریں",
    subject: "مضمون",
    emirate: "امارات",
    gender: "جنس",
    male: "مرد",
    female: "خاتون",
    lessonType: "سبق کی قسم",
    online: "آن لائن",
    inPerson: "ذاتی طور پر",
    minRating: "کم از کم درجہ بندی",
    maxPrice: "زیادہ سے زیادہ قیمت",
    minExperience: "کم از کم تجربہ",
    verifiedOnly: "صرف تصدیق شدہ",
    bookLesson: "سبق بک کریں",
    myBookings: "میری بکنگز",
    upcomingLessons: "آنے والے اسباق",
    completedLessons: "مکمل شدہ اسباق",
    cancelledLessons: "منسوخ شدہ اسباق",
    pending: "زیر التواء",
    confirmed: "تصدیق شدہ",
    completed: "مکمل",
    cancelled: "منسوخ",
    payment: "ادائیگی",
    payNow: "ابھی ادا کریں",
    totalAmount: "کل رقم",
    vat: "ویٹ",
    platformFee: "پلیٹ فارم فیس",
    teacherEarnings: "استاد کی آمدنی",
    paid: "ادا شدہ",
    paymentPending: "ادائیگی زیر التواء",
    paymentSuccess: "ادائیگی کامیاب!",
    paymentCancelled: "ادائیگی منسوخ",
    messages: "پیغامات",
    noMessages: "کوئی پیغام نہیں",
    typeMessage: "اپنا پیغام لکھیں...",
    send: "بھیجیں",
    calendar: "کیلنڈر",
    editProfile: "پروفائل میں ترمیم کریں",
    qualifications: "قابلیت",
    certificates: "سرٹیفکیٹس",
    uploadCertificate: "سرٹیفکیٹ اپ لوڈ کریں",
    bio: "میرے بارے میں",
    meetingLink: "میٹنگ لنک",
    adminDashboard: "ایڈمن ڈیش بورڈ",
    manageTeachers: "اساتذہ کا انتظام",
    manageUsers: "صارفین کا انتظام",
    manageSubjects: "مضامین کا انتظام",
    manageReviews: "جائزوں کا انتظام",
    financialReports: "مالیاتی رپورٹس",
    approve: "منظور کریں",
    reject: "مسترد کریں",
    activate: "فعال کریں",
    deactivate: "غیر فعال کریں",
    pendingApproval: "منظوری زیر التواء",
    totalUsers: "کل صارفین",
    totalStudents: "طلباء",
    totalTeachers: "اساتذہ",
    totalBookings: "بکنگز",
    totalRevenue: "کل آمدنی",
    platformRevenue: "پلیٹ فارم آمدنی",
    subscriptionRevenue: "سبسکرپشن آمدنی",
    save: "محفوظ کریں",
    cancel: "منسوخ کریں",
    delete: "حذف کریں",
    edit: "ترمیم کریں",
    view: "دیکھیں",
    loading: "لوڈ ہو رہا ہے...",
    noResults: "کوئی نتیجہ نہیں",
    success: "کامیابی",
    error: "خرابی",
    confirm: "تصدیق کریں",
    back: "واپس",
    next: "اگلا",
    previous: "پچھلا",
    contactUs: "ہم سے رابطہ کریں",
    address: "پتہ",
    addressValue: "ابوظبی، متحدہ عرب امارات",
    messageTeacher: "استاد کو پیغام بھیجیں",
    bookNow: "ابھی بک کریں",
    viewProfile: "پروفائل دیکھیں",
    searchTeachers: "اساتذہ تلاش کریں",
    requestSpecialist: "ماہر کی درخواست کریں",
    cancelBooking: "بکنگ منسوخ کریں",
    joinClassroom: "کلاس روم میں شامل ہوں",
    startLesson: "سبق شروع کریں",
    endLesson: "سبق ختم کریں",
    freeLessons: "مفت اسباق",
    freeLesson: "مفت سبق",
    enableFreeLessons: "مفت اسباق فعال کریں",
    freeLessonsPerMonth: "فی ماہ مفت اسباق",
    freeLessonsRemaining: "باقی اسباق",
    withdrawals: "نکاسی",
    requestWithdrawal: "نکاسی کی درخواست کریں",
    availableBalance: "دستیاب بیلنس",
    totalEarnings: "کل آمدنی",
    statusPending: "زیر التواء",
    statusConfirmed: "تصدیق شدہ",
    statusCompleted: "مکمل",
    statusCancelled: "منسوخ",
    statusApproved: "منظور شدہ",
    statusRejected: "مسترد شدہ",
  },
  fr: {
    brandName: "Trust Ed Techno",
    brandNameAr: "ترست اي دي تكنو للتطوير والابتكار ذ.م.م",
    tagline: "Connecter les étudiants avec des tuteurs indépendants aux EAU",
    copyright: "© 2026 Trust Ed Techno for Development and Innovation L.L.C. Tous droits réservés.",
    home: "Accueil",
    login: "Connexion",
    register: "Inscription",
    logout: "Déconnexion",
    dashboard: "Tableau de bord",
    profile: "Profil",
    settings: "Paramètres",
    student: "Étudiant",
    teacher: "Enseignant",
    admin: "Administrateur",
    email: "Email",
    password: "Mot de passe",
    confirmPassword: "Confirmer le mot de passe",
    fullName: "Nom complet",
    phone: "Numéro de téléphone",
    registerAs: "S'inscrire en tant que",
    alreadyHaveAccount: "Vous avez déjà un compte ?",
    dontHaveAccount: "Vous n'avez pas de compte ?",
    loginNow: "Se connecter",
    registerNow: "S'inscrire maintenant",
    welcomeBack: "Bon retour",
    createAccount: "Créer un nouveau compte",
    acceptTerms: "J'accepte les conditions générales",
    termsAndConditions: "Conditions générales",
    mustAcceptTerms: "Vous devez accepter les conditions générales",
    subscription: "Abonnement",
    trialPeriod: "Période d'essai",
    daysRemaining: "jours restants",
    subscriptionExpired: "Abonnement expiré",
    renewSubscription: "Renouveler l'abonnement",
    monthlyPlan: "Formule mensuelle",
    yearlyPlan: "Formule annuelle",
    perMonth: "/mois",
    perYear: "/an",
    subscribe: "S'abonner maintenant",
    subscriptionRequired: "Désolé, vous ne pouvez pas accéder. Veuillez renouveler votre abonnement.",
    freeTrial: "3 jours d'essai gratuit",
    findTeacher: "Commencer à apprendre maintenant",
    verifiedTeacher: "Enseignant vérifié",
    verified: "Vérifié ✓",
    subjects: "Matières",
    experience: "Années d'expérience",
    hourlyRate: "Tarif horaire",
    rating: "Note",
    reviews: "Avis",
    noReviews: "Aucun avis pour le moment",
    filters: "Filtres",
    clearFilters: "Effacer les filtres",
    subject: "Matière",
    emirate: "Émirat",
    gender: "Genre",
    male: "Homme",
    female: "Femme",
    lessonType: "Type de cours",
    online: "En ligne",
    inPerson: "En présentiel",
    minRating: "Note minimale",
    maxPrice: "Prix maximum",
    minExperience: "Expérience minimale",
    verifiedOnly: "Vérifiés uniquement",
    bookLesson: "Réserver un cours",
    myBookings: "Mes réservations",
    upcomingLessons: "Cours à venir",
    completedLessons: "Cours terminés",
    cancelledLessons: "Cours annulés",
    pending: "En attente",
    confirmed: "Confirmé",
    completed: "Terminé",
    cancelled: "Annulé",
    payment: "Paiement",
    payNow: "Payer maintenant",
    totalAmount: "Montant total",
    vat: "TVA",
    platformFee: "Frais de plateforme",
    teacherEarnings: "Revenus de l'enseignant",
    paid: "Payé",
    paymentPending: "Paiement en attente",
    paymentSuccess: "Paiement réussi !",
    paymentCancelled: "Paiement annulé",
    messages: "Messages",
    noMessages: "Aucun message",
    typeMessage: "Tapez votre message...",
    send: "Envoyer",
    calendar: "Calendrier",
    editProfile: "Modifier le profil",
    qualifications: "Qualifications",
    certificates: "Certificats",
    uploadCertificate: "Télécharger un certificat",
    bio: "À propos de moi",
    meetingLink: "Lien de réunion",
    adminDashboard: "Tableau de bord administrateur",
    manageTeachers: "Gérer les enseignants",
    manageUsers: "Gérer les utilisateurs",
    manageSubjects: "Gérer les matières",
    manageReviews: "Gérer les avis",
    financialReports: "Rapports financiers",
    approve: "Approuver",
    reject: "Rejeter",
    activate: "Activer",
    deactivate: "Désactiver",
    pendingApproval: "En attente d'approbation",
    totalUsers: "Utilisateurs totaux",
    totalStudents: "Étudiants",
    totalTeachers: "Enseignants",
    totalBookings: "Réservations",
    totalRevenue: "Revenu total",
    platformRevenue: "Revenu de la plateforme",
    subscriptionRevenue: "Revenu des abonnements",
    save: "Enregistrer",
    cancel: "Annuler",
    delete: "Supprimer",
    edit: "Modifier",
    view: "Voir",
    loading: "Chargement...",
    noResults: "Aucun résultat",
    success: "Succès",
    error: "Erreur",
    confirm: "Confirmer",
    back: "Retour",
    next: "Suivant",
    previous: "Précédent",
    contactUs: "Nous contacter",
    address: "Adresse",
    addressValue: "Abu Dhabi, Émirats arabes unis",
    messageTeacher: "Envoyer un message à l'enseignant",
    bookNow: "Réserver maintenant",
    viewProfile: "Voir le profil",
    searchTeachers: "Rechercher des enseignants",
    requestSpecialist: "Demander un spécialiste",
    cancelBooking: "Annuler la réservation",
    joinClassroom: "Rejoindre la classe",
    startLesson: "Commencer le cours",
    endLesson: "Terminer le cours",
    freeLessons: "Cours gratuits",
    freeLesson: "Cours gratuit",
    enableFreeLessons: "Activer les cours gratuits",
    freeLessonsPerMonth: "Cours gratuits par mois",
    freeLessonsRemaining: "Cours restants",
    withdrawals: "Retraits",
    requestWithdrawal: "Demander un retrait",
    availableBalance: "Solde disponible",
    totalEarnings: "Revenus totaux",
    statusPending: "En attente",
    statusConfirmed: "Confirmé",
    statusCompleted: "Terminé",
    statusCancelled: "Annulé",
    statusApproved: "Approuvé",
    statusRejected: "Rejeté",
  },
  ru: {
    brandName: "Trust Ed Techno",
    brandNameAr: "ترست اي دي تكنو للتطوير والابتكار ذ.م.م",
    tagline: "Связываем студентов с независимыми репетиторами в ОАЭ",
    copyright: "© 2026 Trust Ed Techno for Development and Innovation L.L.C. Все права защищены.",
    home: "Главная",
    login: "Вход",
    register: "Регистрация",
    logout: "Выход",
    dashboard: "Панель управления",
    profile: "Профиль",
    settings: "Настройки",
    student: "Студент",
    teacher: "Преподаватель",
    admin: "Администратор",
    email: "Электронная почта",
    password: "Пароль",
    confirmPassword: "Подтвердите пароль",
    fullName: "Полное имя",
    phone: "Номер телефона",
    registerAs: "Зарегистрироваться как",
    alreadyHaveAccount: "Уже есть аккаунт?",
    dontHaveAccount: "Нет аккаунта?",
    loginNow: "Войти",
    registerNow: "Зарегистрироваться",
    welcomeBack: "С возвращением",
    createAccount: "Создать новый аккаунт",
    acceptTerms: "Я принимаю условия и положения",
    termsAndConditions: "Условия и положения",
    mustAcceptTerms: "Вы должны принять условия и положения",
    subscription: "Подписка",
    trialPeriod: "Пробный период",
    daysRemaining: "дней осталось",
    subscriptionExpired: "Подписка истекла",
    renewSubscription: "Продлить подписку",
    monthlyPlan: "Месячный план",
    yearlyPlan: "Годовой план",
    perMonth: "/месяц",
    perYear: "/год",
    subscribe: "Подписаться сейчас",
    subscriptionRequired: "К сожалению, доступ невозможен. Пожалуйста, продлите подписку.",
    freeTrial: "3 дня бесплатно",
    findTeacher: "Начать обучение",
    verifiedTeacher: "Проверенный преподаватель",
    verified: "Проверен ✓",
    subjects: "Предметы",
    experience: "Лет опыта",
    hourlyRate: "Стоимость за час",
    rating: "Рейтинг",
    reviews: "Отзывы",
    noReviews: "Пока нет отзывов",
    filters: "Фильтры",
    clearFilters: "Очистить фильтры",
    subject: "Предмет",
    emirate: "Эмират",
    gender: "Пол",
    male: "Мужской",
    female: "Женский",
    lessonType: "Тип урока",
    online: "Онлайн",
    inPerson: "Очно",
    minRating: "Минимальный рейтинг",
    maxPrice: "Максимальная цена",
    minExperience: "Минимальный опыт",
    verifiedOnly: "Только проверенные",
    bookLesson: "Забронировать урок",
    myBookings: "Мои бронирования",
    upcomingLessons: "Предстоящие уроки",
    completedLessons: "Завершенные уроки",
    cancelledLessons: "Отмененные уроки",
    pending: "В ожидании",
    confirmed: "Подтверждено",
    completed: "Завершено",
    cancelled: "Отменено",
    payment: "Оплата",
    payNow: "Оплатить сейчас",
    totalAmount: "Общая сумма",
    vat: "НДС",
    platformFee: "Комиссия платформы",
    teacherEarnings: "Доход преподавателя",
    paid: "Оплачено",
    paymentPending: "Ожидается оплата",
    paymentSuccess: "Оплата прошла успешно!",
    paymentCancelled: "Оплата отменена",
    messages: "Сообщения",
    noMessages: "Нет сообщений",
    typeMessage: "Введите сообщение...",
    send: "Отправить",
    calendar: "Календарь",
    editProfile: "Редактировать профиль",
    qualifications: "Квалификация",
    certificates: "Сертификаты",
    uploadCertificate: "Загрузить сертификат",
    bio: "О себе",
    meetingLink: "Ссылка на встречу",
    adminDashboard: "Панель администратора",
    manageTeachers: "Управление преподавателями",
    manageUsers: "Управление пользователями",
    manageSubjects: "Управление предметами",
    manageReviews: "Управление отзывами",
    financialReports: "Финансовые отчеты",
    approve: "Одобрить",
    reject: "Отклонить",
    activate: "Активировать",
    deactivate: "Деактивировать",
    pendingApproval: "Ожидает одобрения",
    totalUsers: "Всего пользователей",
    totalStudents: "Студенты",
    totalTeachers: "Преподаватели",
    totalBookings: "Бронирования",
    totalRevenue: "Общий доход",
    platformRevenue: "Доход платформы",
    subscriptionRevenue: "Доход от подписок",
    save: "Сохранить",
    cancel: "Отмена",
    delete: "Удалить",
    edit: "Редактировать",
    view: "Просмотр",
    loading: "Загрузка...",
    noResults: "Нет результатов",
    success: "Успешно",
    error: "Ошибка",
    confirm: "Подтвердить",
    back: "Назад",
    next: "Далее",
    previous: "Предыдущий",
    contactUs: "Связаться с нами",
    address: "Адрес",
    addressValue: "Абу-Даби, Объединенные Арабские Эмираты",
    messageTeacher: "Написать преподавателю",
    bookNow: "Забронировать",
    viewProfile: "Просмотреть профиль",
    searchTeachers: "Поиск преподавателей",
    requestSpecialist: "Запросить специалиста",
    cancelBooking: "Отменить бронирование",
    joinClassroom: "Присоединиться к уроку",
    startLesson: "Начать урок",
    endLesson: "Завершить урок",
    freeLessons: "Бесплатные уроки",
    freeLesson: "Бесплатный урок",
    enableFreeLessons: "Включить бесплатные уроки",
    freeLessonsPerMonth: "Бесплатных уроков в месяц",
    freeLessonsRemaining: "Осталось уроков",
    withdrawals: "Выплаты",
    requestWithdrawal: "Запросить выплату",
    availableBalance: "Доступный баланс",
    totalEarnings: "Общий доход",
    statusPending: "В ожидании",
    statusConfirmed: "Подтверждено",
    statusCompleted: "Завершено",
    statusCancelled: "Отменено",
    statusApproved: "Одобрено",
    statusRejected: "Отклонено",
  },
};

export const getTranslation = (lang, key) => {
  return translations[lang]?.[key] || translations['ar'][key] || key;
};
